import React from 'react';

const RoundProgress = ({ value }) => {
	

	let cores = ['#00FF00', '#008000'];
	
	
	if(value < 1) {
		cores = ['#FF0000', '#940000'];
	}
	
	if(value >= 1 && value < 3) {
		cores = ['#eeff00', '#eeae00'];
	}
	
	value = value?.toLocaleString('pt-BR', {
		maximumFractionDigits: 2,
	});

	const validValue =
		value !== null && value !== undefined ? parseFloat(value) : 0;

	const progressLength = Math.max(0, Math.min(100, validValue));



	return (
		<div className="flex justify-center items-center text-center">
			{/* Circular Progress */}
			<div className="relative md:h-24 md:w-24 w-16 h-16  text-center">
				<svg
					className="h-full w-full"
					width={16}
					height={16}
					viewBox="0 0 36 36"
					xmlns="http://www.w3.org/2000/svg"
				>
					{/* Background Circle */}
					<circle
						cx={18}
						cy={18}
						r={16}
						fill="none"
						className="stroke-current text-gray-200 dark:text-gray-700"
						strokeWidth={4}
					/>
					{/* Progress Circle inside a group with rotation */}
					<g className="origin-center -rotate-90 transform">
						<circle
							cx={18}
							cy={18}
							r={16}
							fill="none"
							className=""
							strokeLinecap="round"
							strokeWidth={4}
							stroke={`url(#gradient)`}
							strokeDasharray={100}
							strokeDashoffset={
								100 - progressLength
							}
						/>
					</g>
					<defs>
						<linearGradient
							id="gradient"
							x1="0%"
							y1="0%"
							x2="100%"
							y2="0%"
						>
							<stop
								offset="0%"
								style={
									{
										stopColor: cores[0],
										stopOpacity: 1,
									}
								}
							/>
							<stop
								offset="100%"
								style={
									{
									stopColor: cores[1],
									stopOpacity: 1,
								}
							}
							/>
						</linearGradient>
					</defs>
				</svg>
				{/* Percentage Text */}
				<div className="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
					<span className="text-center text-normal font-semibold text-white text-lg md:text-2xl">
						{value}
					</span>
				</div>
			</div>
		</div>
	);
};

export default RoundProgress;
